import React from 'react';

const ExplorePage = () => {
  return (
    <div className="p-6">
      <h1 className="text-3xl font-heading font-bold text-heading mb-8">Explore Workloob</h1>
      <div className="text-center py-16">
        <div className="text-6xl mb-4">🌍</div>
        <h2 className="text-xl font-semibold text-gray-900 dark:text-gray-100 mb-2">
          Explore Feature Coming Soon
        </h2>
        <p className="text-gray-600 dark:text-gray-400">
          Discover talents, trending skills, and popular categories.
        </p>
      </div>
    </div>
  );
};

export default ExplorePage;
